class AjaxGetContent {
  constructor(url) {
    this.url = url;
  }

  sendRequest() {
    const _this = this;

    $.get(this.url).fail(function() {
      return "Error";
    });
  }
}

export default AjaxGetContent;
